<template>
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.2167 1.95996L10.2567 0.986641C10.1767 0.906641 10.0834 0.866638 9.97672 0.866638C9.87005 0.866638 9.76337 0.906641 9.69671 0.986641L4.11005 6.65331C4.07005 6.69331 4.04338 6.73331 4.01671 6.78664L3.39005 8.37331C3.33672 8.51998 3.36338 8.6933 3.48338 8.79997C3.56338 8.87997 3.65671 8.91997 3.76337 8.91997C3.81671 8.91997 3.85672 8.90663 3.91005 8.8933L5.48338 8.26664C5.53671 8.23997 5.57671 8.21331 5.61671 8.17331L11.2034 2.50664C11.3767 2.35998 11.3767 2.10663 11.2167 1.95996ZM5.12338 7.55996L4.48338 7.8133L4.73671 7.15996L9.97672 1.83998L10.3767 2.23998L5.12338 7.55996ZM9.20338 7.07997V12.4666C9.20338 12.76 8.93672 13 8.64339 13H1.07005C0.776713 13 0.536713 12.76 0.536713 12.4666V2.30664C0.536713 2.01331 0.776713 1.79997 1.07005 1.79997H6.61671C6.91004 1.79997 7.15004 2.03997 7.15004 2.3333C7.15004 2.62664 6.91004 2.86664 6.61671 2.86664H1.60338V11.9333H8.13671V7.07997C8.13671 6.78663 8.37671 6.54663 8.67005 6.54663C8.96338 6.54663 9.20338 6.78663 9.20338 7.07997Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'editIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>
